import html2canvas from 'html2canvas'

export const getSnapshot = (callback: (base64: string) => void) => {
    const elem: any = document.querySelector("#root")
    html2canvas(elem, {
        scrollY: -window.scrollY,
        allowTaint: true,
        useCORS: true
    })
        .then((canvas) => {
            let base64 = canvas.toDataURL('image/jpeg')
            callback(base64)
        })
        .catch(console.error)
}

export const getSnapshotById = (selector: string, callback: (file: File) => void) => {
    const elem: any = document.querySelector(selector)
    if (elem)
        html2canvas(elem, {
            scrollY: -window.scrollY,
            allowTaint: true,
            useCORS: true
        })
            .then((canvas) => {
                canvas.toBlob((blob: any) => {
                    let file = new File([blob], 'snapshot.jpeg', { type: 'image/jpeg' })
                    callback(file)
                })
            })
            .catch(console.error)
}